

export interface PageDisplayOption {
    key: string;
    label: string;
    page?: number;
}

export const pageDisplayOptions: PageDisplayOption[] = [
    { key: 'page1', label: 'Page 1', page: 1 },
    { key: 'page2', label: 'Page 2', page: 2 },
    { key: 'alternating', label: 'Alternating' },
    { key: 'single', label: 'Single view' },
];
